<template>
	<div>
		<table class="table table-bordered mt-4">
			<tr>
				<td></td>
				<td>
					<strong>Task</strong>
				</td>
				<td>
					<strong>Deadline</strong>
				</td>
			</tr>
			<tr v-for="(t, index) in taskListData"
			    :key="index">
				<td>
					<a href="#"
					   @click.prevent="taskChangeStatus({userId:userInAssistance.id, id:t.id})">
						<i class="fa-check-circle"
						   :class="t.status === 1 ? 'fas' : 'far'"
						   :style="t.status === 1 ? 'color:green' : ''"></i>
					</a>
				</td>
				<td>
					<span :style="strikeOrNot(t.status)">
						{{t.task}}
					</span>
				</td>
				<td nowrap>
					<span :style="strikeOrNot(t.status)">
						{{t.date}}
					</span>
				</td>
			</tr>
		</table>
	</div>
</template>
<script>
	import { mapActions } from 'vuex'

	export default {
		props: {
			userInAssistance: {
				type: Object,
				required: false,
			},

			taskListData: {
				type: Array,
				required: false,
			},
		},

		methods: {
			strikeOrNot(status) {
				return status === 1 ? 'text-decoration: line-through; color: grey' : ''
			},
			...mapActions('n_supercoach', ['taskChangeStatus']),
		},
	}
</script>